module.exports = __webpack_public_path__ + "static/media/IPTV.d0c7d095.png";